import { Theme } from '@mui/material/styles';
import { StyleRules } from '@mui/styles';
import * as React from 'react';

const styles = (theme: Theme): StyleRules => ({
    root: {
        width: 'auto',
        flexGrow: 1,
    },
    subjectivityRoot: {
        margin: '8px',
        minHeight: '24px',
        maxWidth: '800px',
    },
    subjectivityBullet: {
        height: '16px',
        width: '20px',
        '& circle': {
            cx: '10',
            cy: '10',
            r: '4',
            stroke: theme.palette.primary.main,
            strokeWidth: '1',
            fill: theme.palette.primary.main,
        },
    },
    subjectivityText: {
        margin: '5px',
        padding: '5px',
    },
    addSubjectivityButton: {
        backgroundColor: theme.palette.secondary.main,
    },
});

export default styles;
